import DemandStudioSkeleton from '../demand-studio/DemandStudioSkeleton';
import LifecareStudioClientSelector from '../lifecare-studio/LifecareStudioClientSelector';
import FutureCarePreviewHero from './FutureCarePreviewHero';
import FutureCareSignalCard from './FutureCareSignalCard';
import PotentialCareCategoriesCard from './PotentialCareCategoriesCard';
import AttorneyNextStepCard from './AttorneyNextStepCard';
import LifecarePlanDocumentCard from './LifecarePlanDocumentCard';
import RecommendedRouteCard from './RecommendedRouteCard';
import PreliminaryLifecareStatusCard from './PreliminaryLifecareStatusCard';
import {
    fullscreenClasses,
    headerClasses,
    headerLeftClasses,
    headerTitleClasses,
    headerCloseClasses,
    bodyClasses,
    bodyInnerClasses,
    pairGridClasses,
    disclaimerClasses,
} from './preliminaryLifecareClasses';

const PreliminaryLifecarePlanLayout = ({ studioState }) => {
    const {
        caseId,
        caseName,
        isInitialLoadPending,
        lifecareClientIdAndDisplayNames,
        selectedClientId,
        setSelectedClientId,
        previewModel,
        preliminaryStatus,
        onRequestPlan,
        handleClose,
    } = studioState;

    const hasRequestedPlan = preliminaryStatus.requested;

    return (
        <div className={fullscreenClasses}>
            <div className={headerClasses}>
                <div className={headerLeftClasses}>
                    <h1 className={headerTitleClasses}>{caseName}</h1>
                    <LifecareStudioClientSelector
                        lifecareClientIdAndDisplayNames={lifecareClientIdAndDisplayNames}
                        selectedClientId={selectedClientId}
                        setSelectedClientId={setSelectedClientId}
                    />
                </div>
                <div className={headerCloseClasses} onClick={handleClose}>
                    <span>Close</span>
                    <i className="fa fa-times" />
                </div>
            </div>

            <div className={bodyClasses}>
                {isInitialLoadPending ? (
                    <DemandStudioSkeleton />
                ) : (
                    <div className={bodyInnerClasses}>
                        <FutureCarePreviewHero />

                        <div className={pairGridClasses}>
                            <FutureCareSignalCard
                                signal={previewModel.signal}
                                estimate={previewModel.estimate}
                                recordsSummary={previewModel.recordsSummary}
                            />
                            <PotentialCareCategoriesCard
                                categories={previewModel.categories}
                            />
                        </div>

                        {hasRequestedPlan ? (
                            <PreliminaryLifecareStatusCard
                                finalized={preliminaryStatus.finalized}
                                isDownloading={preliminaryStatus.isDownloading}
                                onDownload={preliminaryStatus.downloadZip}
                            />
                        ) : (
                            <AttorneyNextStepCard
                                nextStep={previewModel.nextStep}
                                isRequesting={false}
                                onGenerateProjection={onRequestPlan}
                            />
                        )}

                        <LifecarePlanDocumentCard
                            plan={previewModel.plan}
                            plaintiffName={previewModel.identity.matter}
                            caseId={caseId}
                            clientId={selectedClientId}
                        />

                        {!hasRequestedPlan && <RecommendedRouteCard routes={previewModel.routes} />}

                        <p className={disclaimerClasses}>{previewModel.disclaimer}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PreliminaryLifecarePlanLayout;
